<template>
    <el-row :gutter="8" class="hidden-md-and-down">
      <el-col :span="this.isManager() ? 18 : 24">
<!--        <contacts-popover :row-data="rowData" title="PIC" icon="user" /> -->
      </el-col>

      <el-col v-if="this.isSuper()" align="right" :span="rowData.organisation || rowData.perosn ? 2 : 24">
        <el-button v-show="isSuper()" icon="fa fa-trash" @click="deleteEntry()" :size="buttonSize" type="danger" circle></el-button>
      </el-col>
    </el-row>
  </template>

  <script>
  import PostMixins from '@/mixins/PostMixins'

  export default {
    mixins: [PostMixins],

    props: {
      rowData: {
        type: Object,
        required: true
      },
      buttonSize: {
        type: String,
        default: 'small'
      },
      message: {
        type: String,
        default: 'Delete this Sharer'
      },
      callback: {
        type: Function,
        default: null
      },
      tableRef: {
        type: String,
        default: 'telcotable'
      }
    },

    methods: {
      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/licensees', this.message + ': ' + this.rowData.organisation.name + 'from THIS site', this.onDelete)
      },
      onDelete (response) {
        this.$events.emit(this.tableRef + '-refresh-table')

        if (this.callback) {
          this.callback(this.deleteId, response)
        }
      }
    }
  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>
